import classNames from 'classnames';

import {MiniProportionalMode} from './mini-proportional-mode';
import type {DistributionBarSection} from './types';

import styles from './distribution-bar.module.css';

interface Props {
    sections: DistributionBarSection[];
    widths: number[];
    borderVariant?: 'light' | 'dark';
    size?: 'default' | 'compact' | 'mini';
    showAsPercentage?: boolean;
}

export function ProportionalMode(props: Props) {
    if (props.size === 'mini') {
        return (
            <MiniProportionalMode
                sections={props.sections}
                widths={props.widths}
                borderVariant={props.borderVariant}
                showAsPercentage={props.showAsPercentage}
            />
        );
    }

    const containerClasses = classNames(styles['distribution-bar-container'], {
        [styles['distribution-bar-container--dark']]: props.borderVariant === 'dark',
        [styles['distribution-bar-container--compact']]: props.size === 'compact',
    });

    return (
        <div className={containerClasses}>
            {props.sections.map((section, index) => (
                <div
                    key={section.label}
                    style={{
                        width: `${props.widths[index]}%`,
                        backgroundColor: section.color,
                    }}
                    className={styles['bar-section']}
                >
                    <div
                        className='flex flex-dir-col align-center'
                        style={{color: section.labelColor}}
                    >
                        <span className='font-bold'>
                            {props.showAsPercentage ? `${section.value}%` : section.value}
                        </span>{' '}
                        {section.label}
                    </div>
                </div>
            ))}
        </div>
    );
}
